<template>
    <div>
        <Breadcrumbs main="Admin" submain="Volunteer" title="Register" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div class="form theme-form">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <input class="form-control" type="text" placeholder="Enter your first name" v-model="volunteer.first_name" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <input class="form-control" type="text" placeholder="Enter your last name" v-model="volunteer.last_name" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input class="form-control" type="text" placeholder="Enter your email address" v-model="volunteer.email" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>NID No.</label>
                                            <input class="form-control" type="text" placeholder="Enter your nid no." v-model="volunteer.additional_info.nid" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone No.</label>
                                            <input class="form-control" type="text" placeholder="Enter your phone no." v-model="volunteer.additional_info.phone_number" style="height: 44px;">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Address</label>
                                            <input class="form-control" type="text" placeholder="Enter your address" v-model="volunteer.additional_info.address" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Shelter</label>
                                            <multiselect v-model="assignedShelter" tag-placeholder="Add shelter" placeholder="Search or add a shelter" label="name" :max="shelter_list.length" track-by="id" :options="shelter_list" :multiple="true" :taggable="true"></multiselect>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Image</label>
                                            <div class="flex items-center">
                                                <img v-if="show_image" style="height: 80px;" :src="show_image">
                                                <input :class="volunteer.additional_info.photo ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row mt-4">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                            <router-link to="/volunteer/list">
                                                <button class="btn btn-danger" href="#">Go Back</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Multiselect from 'vue-multiselect';
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import 'sweetalert2/src/sweetalert2.scss'
    
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker,
            Multiselect
        },
    
        data() {
            return {
                isDisabled: false,
                volunteer: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    additional_info: {
                        nid: '',
                        phone_number: '',
                        address: '',
                        shelter: [],
                        photo: null
                    }
                },
                assignedShelter: [],
                show_image: null
            }
        },
    
        computed: {
            ...mapState({
                shelter_list: state => state.shelter.shelter
            })
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
        },
    
        methods: {
            uploadFile(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.show_image = e.target.result
                    this.volunteer.additional_info.photo = e.target.result;
                };
            },
    
            onSubmit() {
                this.isDisabled = true;
                this.assignedShelter.map(item => this.volunteer.additional_info.shelter.push(item.id));
    
                this.$store.dispatch("volunteer/addVolunteer", this.volunteer).then(response => {
                    if (response.code == 200) {
                        this.isDisabled = false,
                        this.volunteer.first_name = ''
                        this.volunteer.last_name = ''
                        this.volunteer.email = ''
                        this.volunteer.additional_info.nid = ''
                        this.volunteer.additional_info.phone_number = ''
                        this.volunteer.additional_info.address = ''
                        this.assignedShelter = []
                        this.volunteer.additional_info.shelter = []
                        this.volunteer.additional_info.photo = null
                        this.show_image = null
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    